<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 13 13"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M11.853 9.003a.58.58 0 0 1-.581.582h-.97V3.577a.97.97 0 0 0-.968-.969H3.326v-.97a.58.58 0 0 1 .581-.58h7.365a.58.58 0 0 1 .581.58v7.365zm-1.938 1.938a.58.58 0 0 1-.581.582H1.969a.58.58 0 0 1-.581-.582V3.577a.58.58 0 0 1 .581-.581h7.365a.58.58 0 0 1 .581.581zM11.272.67H3.907a.97.97 0 0 0-.969.969v.969h-.969A.97.97 0 0 0 1 3.577v7.365a.97.97 0 0 0 .969.969h7.365a.97.97 0 0 0 .969-.97v-.969h.969a.97.97 0 0 0 .969-.969V1.64a.97.97 0 0 0-.97-.97z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="50"
          stroke-width=".5"
          d="M11.853 9.003a.58.58 0 0 1-.581.582h-.97V3.577a.97.97 0 0 0-.968-.969H3.326v-.97a.58.58 0 0 1 .581-.58h7.365a.58.58 0 0 1 .581.58v7.365zm-1.938 1.938a.58.58 0 0 1-.581.582H1.969a.58.58 0 0 1-.581-.582V3.577a.58.58 0 0 1 .581-.581h7.365a.58.58 0 0 1 .581.581zM11.272.67H3.907a.97.97 0 0 0-.969.969v.969h-.969A.97.97 0 0 0 1 3.577v7.365a.97.97 0 0 0 .969.969h7.365a.97.97 0 0 0 .969-.97v-.969h.969a.97.97 0 0 0 .969-.969V1.64a.97.97 0 0 0-.97-.97z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 13,
    },
  },
};
</script>
